<div>
  <div [ngClass]="inlineComponent ? 'no-border-container ' : 'border-container'">
    <div class="flex fl-col gap-4 w-full">
      <div class="flex fl-justify-between fl-al-center w-full">
        <div class="flex items-center gap-2">
          <div class="text-base font-semibold text-[#53565B]">Vehicle Model Details</div>
          @if (connection === 'noActive') {
          <div class="fl-al-center flex gap-2">
            <div
              class="w-[70px] rounded-[40px]"
              style="height: 6px"
              [ngClass]="{ 'bg-[#7E9BD4]': stepNumber === 2, 'bg-[#25508E]': stepNumber === 1 }"
            ></div>
            <div
              class="w-[70px] rounded-[40px]"
              style="height: 6px"
              [ngClass]="{ 'bg-[#25508E]': stepNumber === 2, 'bg-[#DCDCDC]': stepNumber === 1 }"
            ></div>
          </div>
          } @if (connection === 'active') {
          <div class="fl-al-center flex gap-2">
            <div class="rounded h-fit w-fit bg-[#DAF4F2] py-1.5 px-2">
              <div class="text-[10px] leading-[10px] font-bold text-[#1AA140]">Active Connection</div>
            </div>
          </div>
          }
        </div>
        @if(connection === 'active'){
        <span class="disconnect__action--button" (click)="disconnectEstablishedConnection()">
          <span class="material-icons material-icons-round menuitem-icon text-[#EB5757]">link_off</span> Disconnect
        </span>
        }
      </div>

      @if (isLoadingData) {
      <div class="w-full">
        <vehicle-loader [vehicleDetails]="true"></vehicle-loader>
      </div>
      }

      <!-- START: Not Active Connection -->

      @if (connection === 'noActive' && !isLoadingData) {
      <div class="w-full">
        @if (stepNumber === 1) {
        <div class="w-full">
          <form [formGroup]="vehicleForm" class="w-full flex gap-4 fl-al-center fl-col">
            <div class="w-full flex gap-4">
              <div class="w-1/2">
                <mat-form-field floatLabel="auto" appearance="fill" style="width: 100% !important" class="automtic-form-desing-form-only">
                  <mat-label class="automtic-form-desing-lable"> Make </mat-label>
                  <input matInput placeholder="Ex. Volvo" formControlName="make" (ngModelChange)="onValueChange($event)" type="text" required />
                </mat-form-field>
              </div>
              <div class="w-1/2">
                <mat-form-field floatLabel="auto" appearance="fill" style="width: 100% !important" class="automtic-form-desing-form-only">
                  <mat-label class="automtic-form-desing-lable"> Model </mat-label>
                  <input matInput formControlName="model" (ngModelChange)="onValueChange($event)" placeholder="Ex. XC 90" type="text" required />
                </mat-form-field>
              </div>
            </div>
            <div class="w-full">
              <mat-form-field floatLabel="auto" appearance="fill" style="width: 100% !important" class="automtic-form-desing-form-only">
                <mat-label class="automtic-form-desing-lable">Year</mat-label>
                <input
                  matInput
                  [matDatepicker]="dp"
                  [max]="maxDate"
                  placeholder="2024"
                  (ngModelChange)="onValueChange($event)"
                  formControlName="year"
                />
                <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp startView="multi-year" (yearSelected)="onYearSelected($event, dp)"> </mat-datepicker>
              </mat-form-field>
              @if (!isFormValid) {
              <div class="mt-2 mb-4 flex gap-2">
                <mat-icon class="text-xs text-[#EB5757] h-4 w-4">error_outline</mat-icon>
                <div class="text-xs font-semibold text-[#EB5757]">
                  There was an error getting data for this vehicle, please review the data submitted for any errors.
                </div>
              </div>
              }
            </div>
            <div class="w-full">
              <!-- @if(showCopyDataButton){
              <div class="app__common--copy--btn app__centered-item app__form--attribute--title mt-2 mb-4" (click)="copyDataFromGeneralInfo()">
                <span> Copy data from General Information </span>
              </div>
              } -->
              <button
                class="h-[32px] w-full rounded"
                [ngClass]="{ 'bg-[#C1C2C5]': !isFormValid || vehicleForm.invalid, 'bg-[#25508E]': isFormValid && !vehicleForm.invalid }"
                [disabled]="!isFormValid || vehicleForm.invalid"
                (click)="getVehicleData()"
              >
                <span class="text-sm font-semibold text-[#FFFFFF]">Continue</span>
              </button>
            </div>
          </form>
        </div>
        } @if (stepNumber === 2) {
        <div class="w-full">
          <form [formGroup]="vehicleDetailsForm" class="flex gap-4 fl-al-center fl-col w-full">
            <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
              <mat-label class="automtic-form-desing-lable"> Trim </mat-label>
              <mat-select class="example-panel-select" matNativeControl disableOptionCentering formControlName="trim" required>
                @for (item of trimList; track item) {
                <mat-option [value]="item?.value">
                  {{ item?.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" floatLabel="auto" style="width: 100% !important" class="automtic-form-desing-form-only">
              <mat-label class="automtic-form-desing-lable"> Condition </mat-label>
              <mat-select class="example-panel-select" matNativeControl disableOptionCentering formControlName="condition" required>
                @for (item of conditionList; track item) {
                <mat-option [value]="item?.value">
                  {{ item?.label }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div class="w-full">
              <button
                class="h-[32px] w-full rounded"
                [ngClass]="{ 'bg-[#C1C2C5]': !isFormValid || vehicleDetailsForm.invalid, 'bg-[#25508E]': isFormValid && !vehicleDetailsForm.invalid }"
                [disabled]="!isFormValid || vehicleDetailsForm.invalid"
                (click)="saveData()"
              >
                <span class="text-sm font-semibold text-[#FFFFFF]">Connect</span>
              </button>
            </div>
          </form>
        </div>
        }
      </div>
      }

      <!-- START: Active Connection -->

      @if (connection === 'active' && !isLoadingData) {
      <div class="w-full">
        <div class="w-full">
          <div class="flex gap-4 fl-al-center fl-col">
            <form [formGroup]="vehicleForm" class="w-full">
              <div class="w-full flex gap-4">
                <div class="w-1/3">
                  <mat-form-field
                    floatLabel="auto"
                    appearance="fill"
                    style="width: 100% !important"
                    class="automtic-form-desing-form-only readonlyClass"
                    aria-readonly="true"
                  >
                    <mat-label class="automtic-form-desing-lable"> Make </mat-label>
                    <input
                      matInput
                      placeholder="Ex. Volvo"
                      formControlName="make"
                      (ngModelChange)="onValueChange($event)"
                      type="text"
                      required
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="w-1/3">
                  <mat-form-field
                    floatLabel="auto"
                    appearance="fill"
                    style="width: 100% !important"
                    class="automtic-form-desing-form-only custom-vehicale-form-field readonlyClass"
                  >
                    <mat-label class="automtic-form-desing-lable"> Model </mat-label>
                    <input matInput formControlName="model" (ngModelChange)="onValueChange($event)" placeholder="Ex. XC 90" type="text" required />
                  </mat-form-field>
                </div>
                <div class="w-1/3">
                  <mat-form-field
                    floatLabel="auto"
                    appearance="fill"
                    style="width: 100% !important"
                    class="automtic-form-desing-form-only readonlyClass"
                  >
                    <mat-label class="automtic-form-desing-lable"> Year </mat-label>
                    <input
                      matInput
                      formControlName="year"
                      (ngModelChange)="onValueChange($event)"
                      placeholder="Trade-In Value"
                      type="text"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>
            </form>
            <form [formGroup]="vehicleDetailsForm" class="w-full flex gap-4 fl-al-center fl-col">
              <div class="w-full">
                <mat-form-field
                  floatLabel="auto"
                  appearance="fill"
                  style="width: 100% !important"
                  class="automtic-form-desing-form-only readonlyClass"
                >
                  <mat-label class="automtic-form-desing-lable"> Trim </mat-label>
                  <input matInput placeholder="Ex. Volvo" formControlName="trim" (ngModelChange)="onValueChange($event)" type="text" required />
                </mat-form-field>
              </div>
              <div class="w-full">
                <mat-form-field
                  floatLabel="auto"
                  appearance="fill"
                  style="width: 100% !important"
                  class="automtic-form-desing-form-only readonlyClass"
                >
                  <mat-label class="automtic-form-desing-lable"> Condition </mat-label>
                  <input matInput formControlName="condition" (ngModelChange)="onValueChange($event)" placeholder="Ex. XC 90" type="text" required />
                </mat-form-field>
              </div>
              @if (isFormEditMode) {
              <div class="w-full">
                <button
                  class="h-[32px] w-full rounded border border-[#25508E] bg-[#FFFFFF]"
                  [disabled]="!isFormValid"
                  (click)="updateVehicleDetails()"
                >
                  <div class="text-sm font-semibold text-[#25508E]">Update Vehicle Details</div>
                </button>
              </div>
              }
            </form>
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</div>
